import candidateEditor from './editor/index.vue'
import BlankLayout from '../layout/blankLayout.vue'
import AgencyApplicationProfileRoute from './profile/route'

const basePath = '/v-agency'

const routes = [
  {
    name: 'headhunterAddCandidate',
    path: `${basePath}/application/job/:jobId/add`,
    component: candidateEditor,
    meta: {
      isEditMode: false,
      titleI18nKey: 'personal.resume.tabTitle.resumeAdd',
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  },
  {
    name: 'headhunterEditCandidate',
    path: `${basePath}/application/job/:jobId/edit/:applicationId`,
    component: candidateEditor,
    meta: {
      isEditMode: true,
      titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  },
  AgencyApplicationProfileRoute
]

const agencyRoute = {
  path: '/v-agency',
  component: BlankLayout,
  children: routes,
  meta: {
    titleI18nKey: 'personal.resume.tabTitle.resumeAdd'
  }
}

export default agencyRoute
